import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { ApplicationService } from '../../../api/application/application.service';
import { ApplicationModel } from '../../../api/application/application';
import { ReplaceDataService } from 'api/replacedata/replacedata.service';

import { MasterDataConstant } from '../../../api/masterdata.constant';

declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'application-page',
    templateUrl: './application.html'
})
export class ApplicationComponent implements OnInit {
    applicationList: ApplicationModel[];
    application: ApplicationModel;
    totalapplication: number = 0;
    appname = "";
    appsku = "";
    appandroidpackagename = "";
    appandroidsecretkey = "";
    appandroidfirebasekey = "";
    appiospackagename = "";
    appiossecretkey = "";
    appiosfirebasekey = "";
    apphuaweipackagename = "";
    apphuaweikey = "";
    apphuaweiappkey = "";
    apphuaweisecretkey = "";
    message: string;
    id: string;
    role: string;
    i: number;
    constructor(private masterdataservice: MasterDataConstant,private applicationService: ApplicationService,
        private router: Router, private ReplaceDataService: ReplaceDataService) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'DEVELOPER')) {
            this.role = localStorage.getItem('type')
            this.initApplicationList();
        } else {
            this.router.navigate(['/']);
        }
    }
    initApplicationList() {
        this.applicationService
            .allApplication("0")
            .then(
                data => {
                    this.applicationList = data;
                    this.totalapplication = this.applicationList.length;
                }
            );
    }
    cancelAction() {
        this.appname = "";
        this.appsku = "";
        this.appandroidpackagename = "";
        this.appandroidsecretkey = "";
        this.appandroidfirebasekey = "";
        this.appiospackagename = "";
        this.appiossecretkey = "";
        this.appiosfirebasekey = "";
        this.apphuaweipackagename = "";
        this.apphuaweikey = "";
        this.apphuaweiappkey = "";
        this.apphuaweisecretkey = "";
    }
    navigatetokeyword(devicesubtype) {
        $(function () {
            $("#devicesubTypeModal").modal('toggle');
        });
        window.open(window.location.href + '/' + this.application.sku + '/' + this.application.id + '/' + devicesubtype, '_self');
    }
    submitApplication() {
        if (this.appsku == undefined || this.appsku == "") {
            $.notify({
                message: "Please Enter Sku Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appname == undefined || this.appname == "") {
            $.notify({
                message: "Please Enter Application Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appandroidsecretkey == undefined || this.appandroidsecretkey == "") {
            $.notify({
                message: "Please Enter Android Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appandroidsecretkey.length != 32) {
            $.notify({
                message: "Please Enter Valid Android Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appiossecretkey == undefined || this.appiossecretkey == "") {
            $.notify({
                message: "Please Enter iOS Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appiossecretkey.length != 32) {
            $.notify({
                message: "Please Enter Valid iOS Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else {
            if (this.appandroidfirebasekey == undefined) {
                this.appandroidfirebasekey = "";
            }
            if (this.appiosfirebasekey == undefined) {
                this.appiosfirebasekey = "";
            }
            if (this.appandroidpackagename == undefined) {
                this.appandroidpackagename = "";
            }
            if (this.appiospackagename == undefined) {
                this.appiospackagename = "";
            }
            if (this.apphuaweipackagename == undefined) {
                this.apphuaweipackagename = "";
            }
            if (this.apphuaweikey == undefined) {
                this.apphuaweikey = "";
            }
            if (this.apphuaweiappkey == undefined) {
                this.apphuaweiappkey = "";
            }
            if (this.apphuaweisecretkey == undefined) {
                this.apphuaweisecretkey = "";
            }
            let registeruser = {
                appname: this.appname,
                skuname: this.appsku,
                androidpackagename: this.appandroidpackagename,
                androidkey: this.appandroidsecretkey,
                androidfirebasetoken: this.appandroidfirebasekey,
                iospackagename: this.appiospackagename,
                ioskey: this.appiossecretkey,
                iosfirebasetoken: this.appiosfirebasekey,
                huaweipackagename: this.apphuaweipackagename,
                huaweikey: this.apphuaweikey,
                huaweiappkey: this.apphuaweiappkey,
                huaweisecretkey: this.apphuaweisecretkey,
            }
            this.applicationService
                .addApplication(registeruser)
                .then(data => {
                    if (data.status == true) {
                        this.message = data.message
                                this.applicationService
                                    .allApplication("0")
                                    .then(
                                        data => {
                                            this.applicationList = data;
                                            this.totalapplication = this.applicationList.length;
                                        }
                                    );
                                $.notify({
                                    message: this.message
                                }, {
                                    type: 'success',
                                    placement: {
                                        from: 'bottom',
                                        align: 'left'
                                    },
                                    delay: 100,
                                    timer: 100
                                });
                                this.cancelAction();
                                $(function () {
                                    $("#example3").modal('toggle');
                                });
                                this.masterdataservice.ApplicationList = [];
                    } else {
                        this.message = data.message
                        $.notify({
                            message: this.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                });
        }
    }
    showApplication(i, application) {
        this.i = i;
        this.id = application.id;
        this.appname = application.appname;
        this.appsku = application.sku;
        this.appandroidpackagename = application.androidpackagename;
        this.appandroidsecretkey = application.androidkey;
        this.appandroidfirebasekey = application.androidfirebasetoken;
        this.appiospackagename = application.iospackagename;
        this.appiossecretkey = application.ioskey;
        this.appiosfirebasekey = application.iosfirebasetoken;
        this.apphuaweipackagename = application.huaweipackagename;
        this.apphuaweikey = application.huaweikey;
        this.apphuaweiappkey = application.huaweiappkey;
        this.apphuaweisecretkey = application.huaweisecretkey;
        this.application = application;
    }
    updateApplication() {
        if (this.appname == undefined || this.appname == "") {
            $.notify({
                message: "Please Enter Application Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appsku == undefined || this.appsku == "") {
            $.notify({
                message: "Please Enter Sku Name"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appandroidsecretkey == undefined || this.appandroidsecretkey == "") {
            $.notify({
                message: "Please Enter Android Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appandroidsecretkey.length != 32) {
            $.notify({
                message: "Please Enter Valid Android Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appiossecretkey == undefined || this.appiossecretkey == "") {
            $.notify({
                message: "Please Enter iOS Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else if (this.appiossecretkey.length != 32) {
            $.notify({
                message: "Please Enter Valid iOS Secret Key"
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            })
        }
        else {
            if (this.appandroidfirebasekey == undefined) {
                this.appandroidfirebasekey = "";
            }
            if (this.appiosfirebasekey == undefined) {
                this.appiosfirebasekey = "";
            }
            if (this.appandroidpackagename == undefined) {
                this.appandroidpackagename = "";
            }
            if (this.appiospackagename == undefined) {
                this.appiospackagename = "";
            }
            if (this.apphuaweipackagename == undefined) {
                this.apphuaweipackagename = "";
            }
            if (this.apphuaweikey == undefined) {
                this.apphuaweikey = "";
            }
            if (this.apphuaweiappkey == undefined) {
                this.apphuaweiappkey = "";
            }
            if (this.apphuaweisecretkey == undefined) {
                this.apphuaweisecretkey = "";
            }
            let uApplication = {
                appname: this.appname,
                skuname: this.application.sku,
                androidpackagename: this.appandroidpackagename,
                androidkey: this.appandroidsecretkey,
                androidfirebasetoken: this.appandroidfirebasekey,
                iospackagename: this.appiospackagename,
                ioskey: this.appiossecretkey,
                iosfirebasetoken: this.appiosfirebasekey,
                huaweipackagename: this.apphuaweipackagename,
                huaweikey: this.apphuaweikey,
                huaweiappkey: this.apphuaweiappkey,
                huaweisecretkey: this.apphuaweisecretkey
            }
            this.applicationService
                .updateApplication(this.id, uApplication)
                .then(data => {
                    if (data.status) {
                        this.applicationList[this.i] = data.data;
                                $.notify({
                                    message: data.message
                                }, {
                                    type: 'success',
                                    placement: {
                                        from: 'bottom',
                                        align: 'left'
                                    },
                                    delay: 100,
                                    timer: 100
                                });
                                $(function () {
                                    $('#exampleModal').modal('toggle');
                                });
                                this.masterdataservice.ApplicationList = [];
                    } else {
                        $.notify({
                            message: data.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                });
        }
    }
    deleteApplication(i, application) {
        if (localStorage.getItem('type') == 'SUPERADMIN') {
            this.i = i;
            this.id = application.id;
            $(function () {
                $('#deleteModal').modal('toggle');
            });
        }
        else {
            $(function () {
                $('#deleteNotAuthorizedModal').modal('toggle');
            });
        }
    }
    deleteApp() {
        this.applicationService
            .deleteApplication(this.id)
            .then(data => {
                if (data.status == true) {
                    this.applicationList.splice(this.i, 1)
                            $.notify({
                                message: data.message
                            }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'left'
                                },
                                delay: 100,
                                timer: 100
                            });
                            $(function () {
                                $('#deleteModal').modal('toggle');
                            });
                            this.masterdataservice.ApplicationList = [];
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/application/application.page.ts